import { render, staticRenderFns } from "./AptReminderSidebar.vue?vue&type=template&id=488fd399&scoped=true"
import script from "./AptReminderSidebar.vue?vue&type=script&lang=js"
export * from "./AptReminderSidebar.vue?vue&type=script&lang=js"
import style0 from "./AptReminderSidebar.vue?vue&type=style&index=0&id=488fd399&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488fd399",
  null
  
)

export default component.exports